import { render, staticRenderFns } from "./EditDept.vue?vue&type=template&id=3a00fc5c&scoped=true&"
import script from "./EditDept.vue?vue&type=script&lang=js&"
export * from "./EditDept.vue?vue&type=script&lang=js&"
import style1 from "./EditDept.vue?vue&type=style&index=1&id=3a00fc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a00fc5c",
  null
  
)

export default component.exports